(function () {
  'use strict';
  if (customElements.get('product-crosshair')) return;

  class ProductCrosshair extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      var root = this.closest('[data-product-section]');
      var surface = this.parentElement;
      if (!root || !surface) return;
      this.controller = new AbortController();
      var options = { signal: this.controller.signal };
      var pointer = window.matchMedia('(any-hover: hover) and (any-pointer: fine)');
      var svg = this.querySelector('svg');
      var lines = this.querySelector('[data-crosshair-lines]');
      var point = this.querySelector('[data-crosshair-point]');
      var labelX = this.querySelector('[data-crosshair-x]');
      var labelY = this.querySelector('[data-crosshair-y]');
      var frame = 0;
      var sample = null;
      var hide = () => {
        cancelAnimationFrame(frame);
        frame = 0;
        sample = null;
        this.hidden = true;
      };
      this.hide = hide;
      var paint = () => {
        frame = 0;
        if (!sample || !sample.image.isConnected) return hide();
        var box = (sample.image.closest('.product-gallery-viewport') || sample.image).getBoundingClientRect();
        var origin = surface.getBoundingClientRect();
        var x = sample.x - box.left;
        var y = sample.y - box.top;
        if (!box.width || !box.height || x < 0 || y < 0 || x > box.width || y > box.height) return hide();
        // CSS-pixel coordinates refer to the displayed image box, including its
        // contained margins. Nothing is inferred from the source image resolution.
        this.style.left = (box.left - origin.left + surface.scrollLeft - surface.clientLeft) + 'px';
        this.style.top = (box.top - origin.top + surface.scrollTop - surface.clientTop) + 'px';
        this.style.width = box.width + 'px';
        this.style.height = box.height + 'px';
        svg.setAttribute('viewBox', '0 0 ' + box.width + ' ' + box.height);
        lines.setAttribute('d', 'M0 ' + y + 'H' + (x - 4) + 'M' + (x + 4) + ' ' + y + 'H' + box.width +
          'M' + x + ' 0V' + (y - 4) + 'M' + x + ' ' + (y + 4) + 'V' + box.height);
        point.setAttribute('x', x - 3);
        point.setAttribute('y', y - 3);
        labelX.textContent = String(Math.round(x)).padStart(3, '0');
        labelY.textContent = String(Math.round(y)).padStart(3, '0');
        this.hidden = false;
      };
      surface.addEventListener('pointermove', event => {
        if (!pointer.matches || event.pointerType === 'touch' || event.buttons || root.querySelector('dialog[open]')) return hide();
        var trigger = event.target.closest('[data-gallery-open]');
        var image = trigger && (trigger.matches('img') ? trigger : trigger.querySelector('img'));
        if (!image || !image.closest('[data-product-gallery-layout]') || trigger.getAttribute('aria-hidden') === 'true' || !image.naturalWidth) return hide();
        sample = { image: image, x: event.clientX, y: event.clientY };
        if (!frame) frame = requestAnimationFrame(paint);
      }, options);
      surface.addEventListener('pointerleave', hide, options);
      surface.addEventListener('dragstart', hide, options);
      root.addEventListener('product-gallery:change', hide, options);
      root.addEventListener('beforetoggle', event => {
        if (event.target.matches('dialog') && event.newState === 'open') hide();
      }, { ...options, capture: true });
      document.addEventListener('pointerdown', hide, { ...options, capture: true });
      document.addEventListener('pointercancel', hide, options);
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape' || (['Enter', ' '].includes(event.key) && event.target.closest('[data-gallery-open]'))) hide();
      }, options);
      document.addEventListener('visibilitychange', hide, options);
      document.addEventListener('variant:change', event => {
        if (!event.detail?.sectionId || String(event.detail.sectionId) === root.dataset.sectionId) hide();
      }, options);
      document.addEventListener('shopify:section:unload', event => {
        if (event.target === root || event.target.contains(root)) this.disconnectedCallback();
      }, options);
      window.addEventListener('scroll', hide, { ...options, capture: true, passive: true });
      window.addEventListener('resize', hide, options);
      window.addEventListener('blur', hide, options);
      pointer.addEventListener('change', hide, options);
      this.observer = new MutationObserver(hide);
      this.observer.observe(surface, { subtree: true, attributes: true, attributeFilter: ['data-media-id', 'aria-hidden'] });
    }

    disconnectedCallback() {
      this.hide?.();
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = null;
    }
  }
  customElements.define('product-crosshair', ProductCrosshair);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('product-crosshair').forEach(element => element.connectedCallback());
  });
})();
